import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Pantry from './pages/Pantry';
import MealPlans from './pages/MealPlans';
import GroceryLists from './pages/GroceryLists';
import Household from './pages/Household';
import Account from './pages/Account';
import Login from './pages/Login';
import { apolloClient } from './config/apollo';
import './config/amplify';
import './App.css';
import RealtimeIndicator from './components/RealtimeIndicator';

function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="pantry" element={<Pantry />} />
            <Route path="meal-plans" element={<MealPlans />} />
            <Route path="grocery-lists" element={<GroceryLists />} />
            <Route path="household" element={<Household />} />
            <Route path="account" element={<Account />} />
            {/* Redirect old profile route to account */}
            <Route path="profile" element={<Navigate to="/account" replace />} />
          </Route>

          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <RealtimeIndicator />
        </AuthProvider>
      </BrowserRouter>
    </ApolloProvider>
  );
}

export default App;
